( ( $ ) => {
	if ( $( '.tabs' ).length > 0 ) {
		$( '.tabs' ).each( function () {
			let i = 0;
			$( this ).find( '.tab' ).each( function () {
				const title = $( this ).data( 'title' );
				const tabId = $( this ).attr( 'id' );
				$( this ).closest( '.tabs' ).find( '.tabs-nav' ).find( 'ul' ).append( '<li><a class="tab-link" href="#' + tabId + '">' + title + '</a></li>' );
				if ( 0 === i ) {
					$( this ).find( '.tabs-nav__chosen span' ).text( title );
				}
				i++;
				$( this ).hide();
			} );
		} );

		$( document ).on( 'click', '.tabs-nav li a', function ( event ) {
			event.preventDefault();

			const txt = $( this ).text();
			$( this ).closest( '.tabs-nav' ).find( '.tabs-nav__chosen span' ).text( txt );
			$( this ).closest( '.tabs-nav' ).find( '.tabs-nav__menu' ).toggleClass( 'open ' );

			$( this ).closest( '.tabs-nav' ).find( 'li' ).each( function () {
				$( this ).removeClass( 'active' );
			} );

			$( this ).parent().addClass( 'active' );
			const href = $( this ).attr( 'href' );

			$( href ).fadeIn();
			$( this ).closest( '.tabs' ).find( '.tab' ).not( $( href ) ).fadeOut( 0 );

		} );

		$( '.tabs-nav__chosen' ).on( 'click', function () {
			$( this ).siblings( '.tabs-nav__menu' ).toggleClass( 'open ' );
		} );

		$( '.tabs' ).each( function () {
			const active_a = $( this ).find( '.tabs-nav__menu ul li' ).eq( 0 ).find( 'a ' );
			active_a.trigger( 'click' );
			active_a.closest( '.tabs-nav__menu' ).removeClass( 'open ' );
		} );
	}
} )( jQuery )
